import TravelConfigurationTags from '@/modules/travel/common/models/APP/TravelConfigurationTags'
import Configurations from '@/modules/common/common/models/APP/Configuration'
import schema from '@/modules/travel/common/schemas/APP/TravelConfigurationsSchema'
import { validate } from '@/utils/schemaValidatorUtils'
import type { OptionsValuesInterface } from '@/modules/core/models/types'
import InsuranceType from '@/modules/common/common/models/DXP/InsuranceType'
import { TravelMinMaxAges } from './TravelMinMaxAges'
import type { CommonProperty } from '@/modules/health/rater/models/DXP/ConfigurationsProperties'

export default class TravelConfigurations extends Configurations<TravelMinMaxAges> {
  tags!: TravelConfigurationTags
  insuranceTypes: Record<string, InsuranceType>
  destinationTypes: Record<string, InsuranceType>
  paymentTypes: Record<string, InsuranceType>
  maxYearsDeparture: number
  maxYearsReturn: number

  constructor(data: any = {}) {
    if (data && Object.keys(data).length > 0) {
      validate(schema, data)
    }

    super(data)

    this.insuranceTypes = {}
    if (data?.insuranceTypes && Object.keys(data.insuranceTypes).length > 0) {
      Object.keys(data.insuranceTypes).forEach((k) => {
        this.insuranceTypes[k] = new InsuranceType(data.insuranceTypes[k])
      })
    }

    this.destinationTypes = {}
    if (data?.destinationTypes && Object.keys(data.destinationTypes).length > 0) {
      Object.keys(data.destinationTypes).forEach((k) => {
        this.destinationTypes[k] = new InsuranceType(data.destinationTypes[k])
      })
    }

    this.paymentTypes = {}
    if (data?.paymentTypes && Object.keys(data.paymentTypes).length > 0) {
      Object.keys(data.paymentTypes).forEach((k) => {
        this.paymentTypes[k] = new InsuranceType(data.paymentTypes[k])
      })
    }

    if (data?.tags) {
      this.tags = new TravelConfigurationTags(data.tags)
    }

    this.maxYearsDeparture = Number(data.maxYearsDeparture)
    this.maxYearsReturn = Number(data.maxYearsReturn)

    if (data.hiringMaxAges) {
      this.hiringMaxAges = new TravelMinMaxAges(data.hiringMaxAges)
    }
  }

  get insuranceTypesOptions(): OptionsValuesInterface[] {
    return this.parseToOptions(this.insuranceTypes)
  }

  get defaultInsuranceType(): string | null {
    const defaulOption = this.getDefaultValue(this.insuranceTypes)
    if (defaulOption) {
      return defaulOption
    }
    const options: CommonProperty[] = Object.values(this.insuranceTypes)
    return options[0]?.id
  }

  get destinationTypesOptions(): OptionsValuesInterface[] {
    return this.parseToOptions(this.destinationTypes)
  }

  get defaultDestinationType(): string | null {
    const defaulOption = this.getDefaultValue(this.destinationTypes)
    if (defaulOption) {
      return defaulOption
    }
    const options: CommonProperty[] = Object.values(this.destinationTypes)
    return options[0]?.id
  }

  get paymentTypesOptions(): OptionsValuesInterface[] {
    return this.parseToOptions(this.paymentTypes)
  }

  get defaultPaymentType(): string | null {
    return this.getDefaultValue(this.paymentTypes)
  }
}
